import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

const Icon_ = ({
    className,
    type,
    productIcon,
    small,
    tiny,
    title = "",
    ...props
}) => (
    <>
        <span {...{ className, title }} {...props} aria-hidden={true} />

        {title && (
            <span className="is-sr-only" {...props}>
                {title}
            </span>
        )}
    </>
);
const Icon = styled(Icon_)`
    @media screen and (min-width: $desktop) {
        width: 25px;
        height: 25px;
    }

    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    height: 28px;
    width: 24px;

    ${({ productIcon = false }) =>
        productIcon &&
        css`
            width: 80px;
            height: 50px;

            @media screen and (min-width: $desktop) {
                height: 65px;
            }
        `}

    ${({ small = false }) =>
        small &&
        css`
            width: 14px;
            height: 14px;
        `}

    ${({ tiny = false }) =>
        tiny &&
        css`
            width: 10px;
            height: 10px;
        `}

    ${({ type }) => css`
        /* stylelint-disable string-no-newline */
        background-image: url("/components/shared/Icon/${type.startsWith(
            "arrow"
        )
            ? type.endsWith("Black")
                ? "arrowBlack"
                : "arrow"
            : type}.svg");
        /* stylelint-enable string-no-newline */
    `}

    ${({ type }) =>
        type.startsWith("arrow") &&
        css`
            transform: rotate(
                ${(({
                    Up: 0,
                    Right: 1,
                    Down: 2,
                    Left: 3,
                }[type.match(/^arrow(\w+?) (?:Black) ?$/)[1]] +
                    4 -
                    (type.endsWith("Black") ? 1 : 0)) %
                    4) /
                4}
            );
        `}
`;
export default Icon;
